/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_EmailsInputs */

const en_dialog_emails = /** @type {(inputs: Dialog_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emails`)
};

const es_dialog_emails = /** @type {(inputs: Dialog_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correos electrónicos`)
};

/**
* | output |
* | --- |
* | "Emails" |
*
* @param {Dialog_EmailsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_emails = /** @type {((inputs?: Dialog_EmailsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_EmailsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_emails(inputs)
	return en_dialog_emails(inputs)
});